import React from 'react';
import './ResultsSection.css';

import { kindergartenscountword } from '../../../../../components/helpers/wordsnumber';

const ResultsSection = ({ totalCount = 560, displayedCount = 24, isListView = false, setListView, onlyList=false, Checked = 0 }) => {

  const setListView_ = (e, value)=>{
    e.preventDefault();
    setListView(value);
  }
  
  return (
    <div className="results-section">
      <div className="results-container">
        <div className="results-info">
          <span className="results-text">Відображається {displayedCount} {kindergartenscountword(displayedCount)} з {totalCount}</span>
          { Checked > 0 &&  <span className="results-text">Обрано {Checked} {kindergartenscountword(Checked)}</span>}
        </div>
        {!onlyList && <div className="view-controls">
          <span className="view-label">Відображати</span>
          <div className="view-buttons">
            <a href="" className={`view-btn ${!isListView ? 'active' : ''}`} onClick={(e)=>setListView_(e,false)}>Картками</a>
            <a href="" className={`view-btn ${isListView ? 'active' : ''}`} onClick={(e)=>setListView_(e, true)}>Списком</a>
          </div>
        </div>}
      </div>
    </div>
  );
};

export default ResultsSection;